export const pallete = {
  primary: {
    main: `#1890FF`,
  },
  secondary: {
    main: `#88c8fb`,
  },
  tertiary: {
    main: `#5CDBD3`,
  },
  gray: {
    main: `#9EA2A8`,
    [0]: `#EEEDEC`,
    [2]: `#C0BFC0`,
    [3]: `#9EA2A8`,
    [4]: `#4A4A4A`,
  },
  hint: {
    border: `#91D5FF`,
    background: `#E6F7FF`,
  },
  link: {
    main: `#1890FF`,
  },
  success: {
    main: `#52C41A`,
    border: `#B7EB8F`,
    background: `#F6FFED`,
  },
  warning: {
    main: `#FAAD14`,
    border: `#FFE58F`,
    background: `#FFFBE6`,
  },
  error: {
    main: `#FF4D4F`,
    border: `#FFA39E`,
    background: `#FFF1F0`,
  },
  info: { main: `#129DC8` },
  black: { main: `#000000` },
  text: {
    primary: `#212121`,
    secondary: `#757575`,
  },
}

export default pallete
